import { jsx as _jsx } from "react/jsx-runtime";
import { AddressFieldsBasic } from './address-fields-basic/AddressFieldsBasic';
import { AddressFieldsBasicAlt } from './address-fields-basic-alt/AddressFieldsBasicAlt';
import { AddressFieldsBE } from './address-fields-be/AddressFieldsBE';
import { AddressFieldsDE } from './address-fields-de/AddressFieldsDE';
import { AddressFieldsFR } from './address-fields-fr/AddressFieldsFR';
import { AddressFieldsNL } from './address-fields-nl/AddressFieldsNL';
import { AddressFieldsLU } from './address-fields-lu/AddressFieldsLU';
import { AddressFieldsUS } from './address-fields-us/AddressFieldsUS';
import { AddressFieldsUK } from './address-fields-uk/AddressFieldsUK';
export const AddressFields = props => {
    switch (props.country) {
        case 'NL':
            return _jsx(AddressFieldsNL, Object.assign({}, props));
        case 'DE':
            return _jsx(AddressFieldsDE, Object.assign({}, props));
        case 'FR':
            return _jsx(AddressFieldsFR, Object.assign({}, props));
        case 'US':
            return _jsx(AddressFieldsUS, Object.assign({}, props));
        case 'BE':
            return _jsx(AddressFieldsBE, Object.assign({}, props));
        case 'LU':
            return _jsx(AddressFieldsLU, Object.assign({}, props));
        case 'GB':
        case 'GG':
        case 'JE':
            return _jsx(AddressFieldsUK, Object.assign({}, props));
        case 'BFPO':
        case 'IE':
        case 'AU':
        case 'NZ':
            return _jsx(AddressFieldsBasicAlt, Object.assign({}, props));
        default:
            return _jsx(AddressFieldsBasic, Object.assign({}, props));
    }
};
